import { customFieldsApi } from './api'
import type { CustomFieldDefinition, CustomFieldEntityType } from './types'

export const CUSTOM_FIELD_ENTITY_TYPES: readonly CustomFieldEntityType[] = [
    'campaign',
    'ad_group',
    'target',
    'ad',
]

/**
 * There is no cross-entity-type catalog endpoint, so listing definitions
 * across all types (rather than one type at a time, like
 * useCustomFieldCatalog) fans out one request per type and merges the
 * results. Each entity type's definition count is capped at
 * CUSTOM_FIELD_DEFINITION_QUOTA (50 server-side), so this is at most a few
 * hundred rows — cheap to fetch in full on every call.
 */
export const fetchAllCustomFieldDefinitions = async (
    profileId: string,
): Promise<CustomFieldDefinition[]> => {
    const catalogs = await Promise.all(
        CUSTOM_FIELD_ENTITY_TYPES.map((entityType) =>
            customFieldsApi.catalog(profileId, entityType),
        ),
    )
    return catalogs.flatMap((catalog) => catalog.definitions)
}
